import { Box, Button, Typography } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { axiosInstance } from '../../../assets/utils/axiosInstance';
import { useToastNotificationContext } from '../../../hooks/global/alert/useToastNotification';
import authService from '../../../services/authService';
import EnableEmailNotification from '../../whistleblower/enableEmailNotification/enableEmailNotification';
import SwitchButtonComponent from '../../whistleblower/twoFactorAuthentication/switchButtonComponent';
import TwoFactorAuthenticationModal from '../../whistleblower/twoFactorAuthentication/twoFactorAuthenticationModal';

const WhistleSettingsLayout = () => {
  const [switch2FaState, setSwitch2FaState] = useState(false);
  const [isStepOneModalOpen, setIsStepOneModalOpen] = useState(false);
  const [totpFlag, setTotpFlag] = useState(false);
  const [wbTotpAccessFlag, setWbTotpAccessFlag] = useState(false);
  const { createToastNotification } = useToastNotificationContext();
  const [qrCodeLink, setQrCodeLink] = useState('');

  //Fetch Whistleblower access roles
  const fetchAccessRoles = useCallback(async () => {
    const response = await authService.getUserFlags();
    setWbTotpAccessFlag(response.is_totp_enabled);

    //ts-ignore
     
  }, []);

  useEffect(() => {
    fetchAccessRoles();
  }, [fetchAccessRoles]);

  const handle2FaToggle = (newState: boolean) => {
    setSwitch2FaState(newState); // Update the state in the parent component
  };

  const openStepOneModal = async () => {
    if (totpFlag) {
      createToastNotification(
        'User has already configured Google Authenticator TOTP!',
        'error',
      );
    } else {
      const response = await axiosInstance().post('/totp/activate');
      setQrCodeLink(response.data.details);
      setIsStepOneModalOpen(true);
    }
  };

  const closeStepOneModal = () => {
    setIsStepOneModalOpen(false);
  };

  //Checks if the user has already configured their TOTP GOOGLE AUTHENTICATOR
  const checkGoogleAuthenticatorFlag = async () => {
    if (wbTotpAccessFlag) {
      handle2FaToggle(true);
      setTotpFlag(true);
    }
  };

  useEffect(() => {
    checkGoogleAuthenticatorFlag();
    //ts-ignore
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wbTotpAccessFlag]);

  //Deactivate 2FA Checker
  useEffect(() => {
    if (!switch2FaState && totpFlag) {
      const deactivateTotp = async () => {
        await axiosInstance().post('/totp/deactivate');
        createToastNotification('deactivated TOTP Authentication', 'success');
        setSwitch2FaState(false);
        setTotpFlag(false);
        await new Promise((resolve) => setTimeout(resolve, 2000));
        window.location.reload();
      };
      deactivateTotp();
    }
    //ts-ignore
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [switch2FaState]);
  return (
    <div>
      <div>
        <EnableEmailNotification />
        <Box
          sx={{
            width: '560px',
            height: 'auto',
            maxHeight: 'auto',
            borderRadius: '8px',
            border: '1px solid rgba(0, 0, 0, 0.16)',
            bgcolor: '#FFF',
            mt: '24px',
            boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.04)',
            paddingLeft: '24px',
            paddingRight: '24px',
            paddingTop: '24px',
            paddingBottom: '36px',
          }}
        >
          <Typography
            sx={{
              fontFamily: 'Schibsted Grotesk',
              fontWeight: 500,
              fontSize: '18px',
            }}
          >
            <FormattedMessage defaultMessage='Two-Factor Authentication' />
          </Typography>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              mt: '20px',
            }}
          >
            <SwitchButtonComponent
              toggleSwitchState={switch2FaState}
              onToggle={handle2FaToggle}
            />
            <Box style={{ width: '402px', height: '48px' }}>
              <Typography sx={{ color: 'rgba(135, 135, 135, 1)' }}>
                <FormattedMessage defaultMessage='Setup a Time-based One-Time Password (TOTP) Authentication' />{' '}
              </Typography>
            </Box>
          </Box>
          {switch2FaState ? (
            <Box sx={{ display: 'flex', flexDirection: 'row' }}>
              <Button
                onClick={openStepOneModal}
                variant='contained'
                sx={{
                  backgroundColor: 'rgba(36, 73, 252, 1)',
                  width: '210px',
                  height: '38px',
                  borderRadius: '6px',
                  color: 'white',
                  textTransform: 'none',
                  paddingY: '14px',
                  paddingX: '24px',
                  mt: '20px',
                  '&:hover': {
                    backgroundColor: 'rgba(36, 73, 252, 1)', // Remove hover background color
                  },
                }}
              >
                <FormattedMessage defaultMessage='Enable Two-Factor Auth' />
              </Button>
              {totpFlag ? (
                <Typography
                  sx={{
                    color: 'rgba(36, 73, 252, 1)',
                    fontWeight: 500,
                    fontFamily: 'Schibsted Grotesk',
                    ml: '20px',
                    mt: '25px',
                  }}
                >
                  <FormattedMessage defaultMessage='Enabled' />
                </Typography>
              ) : (
                ''
              )}
            </Box>
          ) : (
            ''
          )}
        </Box>
      </div>

      {/* Modal for Step 1 of 2FA TOTP activation */}
      <TwoFactorAuthenticationModal
        open={isStepOneModalOpen}
        handleClose={closeStepOneModal}
        useFlag='whistleblower'
        qrCodeLink={qrCodeLink}
      />
    </div>
  );
};

export default WhistleSettingsLayout;
